<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P6aHZ/tc-custom/9781504084383.jpg?1705289477356" alt="This image is the cover for the book Swallow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Swallow
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Two lovers search for each other through the wilderness of Southern Africa in this classic romantic adventure by the author of <i>King Solomon’s Mines</i>.</b></p><p> Suzanne is a Dutch girl who has grown up among the natives of South Africa, who call her “Swallow.” One day she finds Ralph Kenzie, an English castaway, washed up along the shore. They fall in love, but on their wedding day, she is kidnapped by the deadly Swart Piet. Years pass, and Ralph does not give up his search for his beloved Suzanne. Meanwhile, Suzanne has teamed up with Sihamba, a witch doctor. Together they trek through the wilderness, facing war and other dangers as Suzanne and Ralph make their way back to each other . . .<b> </b></p><b>“A thrilling tale of action and romance, with some mystical elements thrown into the mix and some historical backdrop to add authenticity. . . . <i>Swallow </i>really is a novel that will please just about any reader. I more than highly recommend it.” —<i>Fantasy Literature</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">H. Rider Haggard (1856&ndash;1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including <I>She</I> (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b3030c2